// src/components/store/sections/testimonials/TestimonialV83QuoteminimalSlateGold.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV83QuoteminimalSlateGold(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={83}
      archKey="quote_minimal"
      archLabel="Editorial Quotes"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
